import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import React, { useState } from 'react';
import ErrorImg from '../../assets/images/certificates/error.png';

import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import LastnameCheckImg from '../../assets/images/certificates/lastname_validated.svg';
import FadeLoading from './FadeLoading.jsx';
import ValidationError from './ValidationError.jsx';

export default function TextFieldWithButton({
    text,
    validatedText,
    onSubmit,
    status,
    value,
    onChange,
    styleColor,
    textButtonColor = '#FFFFFF',
    loading,
    loadingTexts = [],
    errorText,
}) {
    const { t } = useTranslation();

    const [showTextField, setShowTextField] = useState(true);

    return (
        <>
            {showTextField && status !== true && (
                <>
                    <FormGroup
                        row
                        sx={{
                            borderRadius: '8px',
                            paddingTop: '1px',
                            paddingBottom: '1px',
                            paddingRight: '5px',
                            border: '1px solid rgba(0, 0, 0, 0.2)',
                        }}
                    >
                        <Grid container sx={{ width: '100%' }}>
                            <Grid size={{ md: 10, lg: 8, xs: 8.2 }} sx={{ alignContent: 'center' }}>
                                <TextField
                                    sx={{
                                        borderBottom: 0,
                                        marginTop: '8px',
                                        marginBottom: '5px',
                                        marginLeft: '16px',
                                        marginRight: '4px',
                                        width: '100%',
                                    }}
                                    value={value}
                                    key={text}
                                    variant="standard"
                                    placeholder={text}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') onSubmit(e);
                                    }}
                                    onChange={(e) => onChange(e)}
                                />
                            </Grid>
                            <Grid size={{ md: 2, lg: 4, xs: 3.8 }}>
                                {status === null && (
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        onClick={() => onSubmit()}
                                        sx={{
                                            marginTop: '5px',
                                            marginBottom: '5px',
                                            width: '100%',
                                            borderRadius: '8px',
                                            fontWeight: 600,
                                            background: styleColor,
                                            border: `1px solid ${textButtonColor}`,
                                            color: textButtonColor,
                                            '&:hover': {
                                                background: styleColor,
                                                opacity: 0.7,
                                            },
                                        }}
                                    >
                                        {t('certificate.validate_button')}
                                    </Button>
                                )}
                                {status === false && (
                                    <img
                                        style={{
                                            display: 'block',
                                            paddingTop: '10px',
                                            paddingRight: '5px',
                                            marginLeft: 'auto',
                                        }}
                                        alt="error"
                                        src={ErrorImg}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </FormGroup>
                    {status === false && <ValidationError text={errorText} />}
                </>
            )}
            {showTextField && status === true && (
                <Grid container>
                    <Grid size={{ md: 12, xs: 11 }}>
                        <Stack
                            direction={'row'}
                            justifyContent={'start'}
                            sx={{ borderRadius: '8px', backgroundColor: '#A7FFDF' }}
                        >
                            <img
                                style={{
                                    paddingRight: 0,
                                    paddingLeft: 8,
                                }}
                                alt="checkImg"
                                src={LastnameCheckImg}
                            />
                            <Box
                                sx={{
                                    padding: 2,
                                    fontFamily: 'Poppins',
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: 'primary.main',
                                }}
                            >
                                {validatedText}
                            </Box>
                        </Stack>
                    </Grid>
                </Grid>
            )}
            <FadeLoading loading={loading} loadingTexts={loadingTexts} onTick={(e) => setShowTextField(e)} />
        </>
    );
}
